import moment from 'moment'
export default function(landPrograms, sailDate, sailingNights) {
  if (!landPrograms || !Object.keys(landPrograms).length) {
    return null
  }
  return Object.entries(landPrograms).reduce((obj, [key, data]) => {
    const type = data.cruiseTourType === 'POSTCRUISE' ? 'post' : 'pre'

    const startDate =
      type === 'pre'
        ? moment(sailDate)
            .subtract(Number(data.duration), 'days')
            .format('YYYY-MM-DD')
        : moment(sailDate)
            .add(Number(sailingNights), 'days')
            .format('YYYY-MM-DD')

    obj[type] = {
      ...data,
      ...data.content,
      type,
      startDate,
      id: key
    }
    return obj
  }, {})
}
